
































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {IProduct} from '@/models/IProduct';
import {getListProducts} from '@/services/ProductService';
import ProductView from '@/components/ProductView.vue';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({
  components: {ProductView}
})
export default class ProductSelect extends Vue {
  @Prop() value!: number[];
  loading: boolean = true;
  products: IProduct[] = [];

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.products = await getListProducts(this.organizationId, this.shopId);
    } finally {
      this.loading = false;
    }
  }

  onChange(value: number[]) {
    this.$emit('input', value);
  }

  filter(item: IProduct, queryText: string, itemText: any) {
    const textOne = item.title.toLowerCase();
    const searchText = queryText.toLowerCase();

    return textOne.indexOf(searchText) > -1;
  }

}
